import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";

import { TextField } from "@material-ui/core";
import { ChromePicker } from "react-color"; // Ensure react-color is installed

import { form } from "../../../messages";
import { useBmapi } from "../../../utils/bmapi-context";

export default function Extra({ values, handleChange }) {
  const intl = useIntl();
  const { bmapi } = useBmapi();

  const extraConfig = bmapi.settings.campaign?.extra;

  // Parse the initial value of `extraMap` from `values.extra`
  const [extraMap, setExtraMap] = useState(() => {
    try {
      return values.extra ? JSON.parse(values.extra) : {};
    } catch {
      return {};
    }
  });

  const [pickerOpen, setPickerOpen] = useState(null); // Internal state for color picker UI

  // Sync `extraMap` when `values.extra` changes externally
  useEffect(() => {
    try {
      const parsed = values.extra ? JSON.parse(values.extra) : {};
      setExtraMap(parsed);
    } catch {
      setExtraMap({});
    }
  }, [values.extra]);

  // Helper to update a field in the `extraMap`
  const updateExtraField = (name, value) => {
    const updatedMap = {
      ...extraMap,
      [name]: value,
    };

    setExtraMap(updatedMap);
    handleChange("extra")({
      target: { value: JSON.stringify(updatedMap) },
    });
  };

  if (!Array.isArray(extraConfig)) {
    return null; // Don't render anything if `extra` is not defined or not an array
  }

  return (
    <div style={{ marginBottom: "16px" }}>
      {/* Single label for the group */}
      <label style={{ display: "block", marginBottom: "8px" }}>
        {intl.formatMessage(form.extra)}
      </label>

      {/* Row container for all subcomponents */}
      <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
        {extraConfig.map((field) => {
          switch (field.type) {
            case "colorPicker":
              return (
                <div
                  key={field.name}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                  }}
                >
                  {/* Color preview */}
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      backgroundColor: extraMap[field.name] || "#ffffff",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      setPickerOpen(
                        pickerOpen === field.name ? null : field.name
                      )
                    }
                  />

                  {/* Popup color picker */}
                  {pickerOpen === field.name && (
                    <div
                      style={{
                        position: "absolute",
                        zIndex: 10,
                        top: "50px",
                        left: 0,
                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
                        background: "#fff",
                        borderRadius: "4px",
                      }}
                    >
                      <ChromePicker
                        color={extraMap[field.name] || "#ffffff"}
                        onChange={(color) =>
                          updateExtraField(field.name, color.hex)
                        }
                        disableAlpha // Optional: Disable alpha transparency if not needed
                      />
                      <button
                        style={{
                          margin: "8px auto",
                          display: "block",
                          padding: "4px 8px",
                          cursor: "pointer",
                          backgroundColor: "#007bff",
                          color: "#fff",
                          border: "none",
                          borderRadius: "4px",
                        }}
                        onClick={() => setPickerOpen(null)}
                      >
                        Close
                      </button>
                    </div>
                  )}
                </div>
              );

            case "textField":
              return (
                <TextField
                  key={field.name}
                  name={field.name}
                  label={field.label}
                  value={extraMap[field.name] || ""}
                  onChange={(e) => updateExtraField(field.name, e.target.value)}
                  fullWidth
                  margin="normal"
                />
              );

            default:
              return null; // Render nothing for unsupported field types
          }
        })}
      </div>
    </div>
  );
}
